export * from './Component';
export type { CommonInputProps } from './typing';
